import cart from "./../images/icon-cart.svg";
import Cart from "./Cart";
import Avatar from "./../images/image-avatar.png";
import Logo from "./../images/logo.svg";
import Menu from "./../images/icon-menu.svg";
import Close from "./../images/icon-close.svg";
import { useState } from "react";

function Header(props) {
  const [navOpen, setNavOpen] = useState(false);

  function handleNavOpen() {
    setNavOpen(true);
  }

  function handleNavClose() {
    setNavOpen(false);
  }
  function showCartItems() {
    document.querySelector(".cart-hover").classList.remove("hidden");
  }
  function hideCartItems() {
    document.querySelector(".cart-hover").classList.add("hidden");
  }
  return (
    <nav
      className="nav"
      onMouseLeave={() => {
        setTimeout(hideCartItems, 2000);
      }}
    >
      <img alt="" src={Menu} className="menu" onClick={handleNavOpen} />
      <img alt="" src={Logo} className="nav-brand" />
      <div className={navOpen ? "nav-links nav-links_open" : "nav-links"}>
        <img
          alt=""
          src={Close}
          className="close-btn"
          onClick={handleNavClose}
        />
        <a href="#no" className="nav-link">
          Collections
        </a>
        <a href="#no" className="nav-link">
          Men
        </a>
        <a href="#no" className="nav-link">
          Women
        </a>
        <a href="#no" className="nav-link">
          About
        </a>
        <a href="#no" className="nav-link">
          Contact
        </a>
      </div>
      <div className="user-n-cart">
        <div className="cart" onMouseEnter={showCartItems}>
          <img alt="" src={cart} />
          <span className="cart-item hidden"></span>
        </div>
        <img alt="" src={Avatar} className="avatar" />
      </div>
      <div className={navOpen ? "overlay overlay-open" : "overlay"}></div>
      <div className="overlay"></div>
      <div className="cart-hover hidden">
        <div className="cart-hover-header">Cart</div>
        <div className="cart-hover-content">
          {props.isEmpty ? (
            <Cart cartNumber={props.cartNumber} />
          ) : (
            "Your cart is empty"
          )}
        </div>
      </div>
    </nav>
  );
}

export default Header;
